export default "__VITE_ASSET__BRrBq30k__"